import React from "react";
import { Grid } from "semantic-ui-react";

import SmallCardLoader from "./SmallCardLoader";
import BigListLoader from "./BigListLoader";

import MainGrid from "../../templates/MainGrid";
import { renderGridElements } from "../../../helpers/ReactHelpers";

export enum definedListLoaderType {
  bigLoader = "bigLoader",
  default = "default",
}
interface Props {
  rows?: number;
  keyTag: string;
  type?: definedListLoaderType;
  bigList?: boolean;
}

const ListLoader: React.FC<Props> = ({ rows, keyTag, type }) => {
  let Loader = SmallCardLoader;
  if (type === definedListLoaderType.bigLoader) {
    Loader = BigListLoader;
  }

  return (
    <div>
      <MainGrid columns={1}>
        <Grid.Column>
          {renderGridElements(rows, <Loader />, keyTag)}
        </Grid.Column>
      </MainGrid>
    </div>
  );
};

ListLoader.defaultProps = {
  rows: 1,
};

export default ListLoader;
